import React from "react";
import LocalizationContext from "../utils/LocalizationContext";
import NavBar from "../components/NavBar";
import Company from "../pages/Company";
import useMenu from "../utils/Hooks/useMenu";
import ValidateURL from "../utils/ValidateURL";

export default () => {
  const menu = useMenu();
  const currentPage = {
    menuGroup: menu?.Company,
    key: "Company",
  };

  return (
    <LocalizationContext.Provider value={null}>
      <ValidateURL currentPage={currentPage}>
        <NavBar
          MenuOptions={menu}
          currentPage={currentPage}
        >
          <Company />
        </NavBar>
      </ValidateURL>
    </LocalizationContext.Provider>
  );
};
